export enum OcbExecutionModes {
    Automatic = 0,
    OnDemand = 1,
    RealTime = 2,
}
